import { type WorldClockCity } from "./timerLogic";

const OPEN_METEO_URL = "https://api.open-meteo.com/v1/forecast";
const WEATHER_REFRESH_MS = 15 * 60 * 1000;

type OpenMeteoResponse = {
  current?: {
    temperature_2m?: number;
  };
};

export async function fetchCityTemperature(
  latitude: number,
  longitude: number,
): Promise<number | null> {
  const url = new URL(OPEN_METEO_URL);
  url.searchParams.set("latitude", String(latitude));
  url.searchParams.set("longitude", String(longitude));
  url.searchParams.set("current", "temperature_2m");
  url.searchParams.set("timezone", "auto");

  const response = await fetch(url);
  if (!response.ok) return null;

  const data = (await response.json()) as OpenMeteoResponse;
  const temp = data.current?.temperature_2m;
  return typeof temp === "number" ? Math.round(temp) : null;
}

export async function fetchWorldClockTemperatures(
  cities: WorldClockCity[],
): Promise<Record<string, number | null>> {
  const entries = await Promise.all(
    cities.map(async (city) => {
      try {
        const temp = await fetchCityTemperature(city.latitude, city.longitude);
        return [city.id, temp] as const;
      } catch {
        return [city.id, null] as const;
      }
    }),
  );

  return Object.fromEntries(entries);
}

export function formatTemperature(celsius: number | null | undefined): string {
  if (celsius == null) return "—";
  return `${celsius}°C`;
}

export { WEATHER_REFRESH_MS };
